export const SCREEN_WIDTH_BREAKPOINT_PX = 1000;
export const SCREEN_WIDTH_BREAKPOINT = SCREEN_WIDTH_BREAKPOINT_PX + "px";
